import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from './store';

export type DialogType = "infoQuality"      // additional info about materials
                       | "infoLegend" 
                       | "infoModel" 
                       | "loadConfig"       // dialog to load an existing configuration
                       | "saveConfig"       // saving configuration after finishing (from here print, etc.)
                       | "deleteConfirm" 
                       | "warningInfo"      // this is a specific warning for sofas, despite the name
                       | "message"          // generic message
                       | "baskets"          // list of baskets & edit basket;

export interface PopupState {
    isOpenPopup: boolean,
    popupContent?: Record<string, any>;    
    dialog: DialogType
}

export interface PopupPayload {
    dialog: DialogType
    popupContent?: Record<string, any>;    
}

const initialState: PopupState = {
    isOpenPopup: false,
    popupContent: {
        qualityId: "",
        code: "",
        mainColor: "",
        tags: [],
        name: ""
    },
    dialog: "infoQuality"
}

export const popUpSlice = createSlice({
    name: 'popup',
    initialState,
    reducers: {
        showPopup: (state, action: PayloadAction<PopupPayload>) => {
            state.popupContent = action.payload.popupContent
            state.dialog = action.payload.dialog
            state.isOpenPopup = true;
        },
        closePopup: (state) => {
            state.isOpenPopup = false;
        },
    }
});

export const { showPopup, closePopup } = popUpSlice.actions;
export default popUpSlice.reducer;

// ==== Selectors ====

export const isOpenSelector = (state: RootState) => state.popup.isOpenPopup;
export const popupContentSelector = (state: RootState) => state.popup.popupContent;
export const dialogTypeSelector = (state: RootState) => state.popup.dialog;
